











 















const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RemoveGitHubAuthMutation_team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamMember",
      "kind": "LinkedField",
      "name": "teamMember",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TeamMemberIntegrations",
          "kind": "LinkedField",
          "name": "integrations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GitHubIntegration",
              "kind": "LinkedField",
              "name": "github",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "accessToken",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "login",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RemoveGitHubAuthPayload",
  "abstractKey": null
};

(node ).hash = "8687e9228a4234e921e24e0b0724087e";

export default node;
